// utils/multiCar.utils.ts
import { toast } from "react-toastify";
import { MultiCarItem, } from "../../home/components/types";
import { Product } from "src/shared/services/interfacev2";

/** Create a new car */
export const createCar = (carNumber: string): MultiCarItem => ({
  carNumber: carNumber.trim(),
  productDetails: [],
  totalPrice: 0,
});

/** Remove a product from a car */
export const removeProduct = (
  car: MultiCarItem,
  productToDelete: Product | null
): MultiCarItem | null => {
  if (!productToDelete) return null;

  const updatedProducts = car.productDetails.filter(
    (p) => p._id.$oid !== productToDelete._id.$oid
  );

  const updatedTotalPrice =
    car.totalPrice - parseFloat(productToDelete.amount);

  if (updatedProducts.length === 0) return null;

  return {
    ...car,
    productDetails: updatedProducts,
    totalPrice: Math.max(updatedTotalPrice, 0),
  };
};


/** Add product to a car */
export const addProduct = (car: MultiCarItem, product: Product): MultiCarItem | null => {
  const productExists = car.productDetails.some(
    (p) => p._id.$oid === product._id.$oid
  );

  if (productExists) {
    toast.error("Product already added to this car.");
    return null;
  }

  return {
    ...car,
    productDetails: [...car.productDetails, product],
    totalPrice: car.totalPrice + parseFloat(product.amount),
  };
};
